const soundBank = [{}, {}, {}, {}, {}, {}, {}, {}, {}];
const keyVals = ['Q', 'W', 'E', 'A', 'S', 'D', 'Z', 'X', 'C'];
const keyCodes = [81, 87, 69, 65, 83, 68, 90, 88, 67];
const id1 = [
  'Heater-1',
  'Heater-2',
  'Heater-3',
  'Heater-4',
  'Clap',
  'Open-HH',
  "Kick-n'-Hat",
  'Kick',
  'Closed-HH',
];
const id2 = [
  'Chord-1',
  'Chord-2',
  'Chord-3',
  'Shaker',
  'Open-HH',
  'Closed-HH',
  'Punchy-Kick',
  'Side-Stick',
  'Snare',
];
const link1 = [
  'https://s3.amazonaws.com/freecodecamp/drums/Heater-1.mp3',
  'https://s3.amazonaws.com/freecodecamp/drums/Heater-2.mp3',
  'https://s3.amazonaws.com/freecodecamp/drums/Heater-3.mp3',
  'https://s3.amazonaws.com/freecodecamp/drums/Heater-4_1.mp3',
  'https://s3.amazonaws.com/freecodecamp/drums/Heater-6.mp3',
  'https://s3.amazonaws.com/freecodecamp/drums/Dsc_Oh.mp3',
  'https://s3.amazonaws.com/freecodecamp/drums/Kick_n_Hat.mp3',
  'https://s3.amazonaws.com/freecodecamp/drums/RP4_KICK_1.mp3',
  'https://s3.amazonaws.com/freecodecamp/drums/Cev_H2.mp3',
];
const link2 = [
  'https://s3.amazonaws.com/freecodecamp/drums/Chord_1.mp3',
  'https://s3.amazonaws.com/freecodecamp/drums/Chord_2.mp3',
  'https://s3.amazonaws.com/freecodecamp/drums/Chord_3.mp3',
  'https://s3.amazonaws.com/freecodecamp/drums/Give_us_a_light.mp3',
  'https://s3.amazonaws.com/freecodecamp/drums/Dry_Ohh.mp3',
  'https://s3.amazonaws.com/freecodecamp/drums/Bld_H1.mp3',
  'https://s3.amazonaws.com/freecodecamp/drums/punchy_kick_1.mp3',
  'https://s3.amazonaws.com/freecodecamp/drums/side_stick_1.mp3',
  'https://s3.amazonaws.com/freecodecamp/drums/Brk_Snr.mp3',
];

soundBank.forEach((k, i) => {
  k.keyVal = keyVals[i];
  k.keyCode = keyCodes[i];
  k.id1 = id1[i];
  k.id2 = id2[i];
  k.link1 = link1[i];
  k.link2 = link2[i];
});

export default soundBank;



// WEBPACK FOOTER //
// ./src/soundBank.js